import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { ColorValue, Image, StyleSheet, View } from 'react-native';
import { RobotDevice } from '../../types';
import { getRobotImgFromType } from '../../utils';

type RobotAvatarBadgeProps = {
  robotDevice?: RobotDevice;
  size?: number;
  isHollow?: boolean;
  color?: ColorValue;
};

export const RobotAvatarBadge = (props: RobotAvatarBadgeProps) => {
  const {
    robotDevice,
    size = 440,
    isHollow = false,
    color = '#ffbf09',
  } = props;

  return (
    <View
      style={[
        {
          height: size,
          width: size,
          borderRadius: size / 2,
          flex: 0,
          borderWidth: 2,
        },
        isHollow
          ? { borderColor: color }
          : { backgroundColor: color, borderColor: 'transparent' },
      ]}
    >
      {robotDevice ? (
        <Image
          style={styles.image}
          source={getRobotImgFromType(robotDevice.type)}
        />
      ) : (
        <View style={[styles.iconContainer, { borderRadius: size / 2 }]}>
          <FontAwesomeIcon
            style={styles.icon}
            icon="robot"
            color="#0000003a"
            size={size / 4.5}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  image: {
    overflow: 'hidden',
    flex: 1,
    width: '100%',
    alignItems: 'center',
  },
  iconContainer: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    overflow: 'hidden',
    alignItems: 'center',
  },
});
